import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6 0a6 6 0 1 0 6 6 6.006 6.006 0 0 0-6-6m-.3 2.4a.9.9 0 1 1 0 1.8.9.9 0 0 1 0-1.8M7.2 9H4.8a.6.6 0 0 1 0-1.2h.6V6h-.6a.6.6 0 0 1 0-1.2H6a.6.6 0 0 1 .6.6v2.4h.6a.6.6 0 0 1 0 1.2"
    }, null, -1)
  ]))]))
}
export default { render: render }